// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"bf5e2e0f","361":"a7a72303","453":"ace21015","558":"7af371c6","625":"89e569c5"}[chunkId] + ".chunk.js";
};